module.exports = __webpack_public_path__ + "img/sheet_admin.1b7e4378.svg";